import React, { useEffect, useState, Fragment, useContext, useRef } from 'react';
import { Popover, Transition } from '@headlessui/react'
import { InformationCircleIcon, ExclamationIcon } from '@heroicons/react/solid'

import { NotificationContext, useNotification } from '../providers/NotificationProvider';
import { useUser } from '../providers/UserProvider';

function NotificationBar() {
  const [ state, dispatch ] = useContext(NotificationContext);
  const [show, setShow] = useState(state.showNotification);
  const [user, userDispatch] = useUser();

  //const [ showNotification, setShowNotifications] = useState(false);
  //const [ notification, setNotification ] = useState("We sent you an email with instructions to reset your password.");

  useEffect(() => {
    setShow(state.showNotification);
  }, [state]);

  return (
    <Transition
      show={show}
      className="space-y-4"
      enter="transform ease-out duration-300 transition"
      enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
      enterTo="translate-y-0 opacity-100 sm:translate-x-0"
      leave="transition ease-in duration-100"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
		>
      {/* <div className={state.class}>
        <div className="absolute z-30 pointer-events-none" aria-hidden="true" />
        <div className="relative z-20">
          <div className="mx-auto text-center py-4 px-8">
            <span className="text-white font-subtitle text-subtitle-mobile md:text-subtitle">{state.notification}</span>
          </div>
        </div>
      </div> */}
      <div className="relative">
        <div className={"p-4 " + state.classes.bg}>
          <div className="flex">
            {state.notification !== 'HIGHLIGHT_PRODUCT_REQUEST_FEATURE' && <div className="flex-shrink-0">
              {state.isError ? <ExclamationIcon className={"h-5 w-5 " + state.classes.icon} /> : <InformationCircleIcon className={"h-5 w-5 " + state.classes.icon} aria-hidden="true" />}
            </div>}
            <div className={state.notification === 'HIGHLIGHT_PRODUCT_REQUEST_FEATURE' ? 'mx-auto': 'ml-3'}>
              {
                state.notification !== 'HIGHLIGHT_PRODUCT_REQUEST_FEATURE' && 
                  <h3 className={"text-xxs xl:text-xs font-primary leading-4 xl:leading-5 font-bold " + state.classes.title}>{state.title}</h3>
              }
              <div className={"text-sm font-primary font-light-medium leading-6 " + state.classes.text}>
                {state.notification === 'HIGHLIGHT_PRODUCT_REQUEST_FEATURE' ? <p>
                  {/* We can negotiate specific discounts for<br className='lg:hidden' /> you.&nbsp; */}
                  We can negotiate discounts on your<br className='lg:hidden' /> upcoming large purchases!&nbsp; 
                  <button
                    type="button"
                    onClick={
                      () => {
                        console.log('fire open product request modal')
                        userDispatch({ type: "productRequest/showModal", payload: true })
                      }
                    }
                    className="underline"
                  >
                    Try it here&nbsp;
                  </button>
                  →
                </p> : state.notification}
              </div>
            </div>
          </div>
        </div>
        <div className='absolute top-0 right-0 h-full flex flex-col justify-center lg:pr-[60px]'>
          <button 
            className='mr-[14px] text-white'
            onClick={() => {
              dispatch({ type: "notification/hide" })
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </Transition>
  )

}

export default NotificationBar;
